export default "__VITE_ASSET__CnKfb8BU__"